/**
 * Regular Expression used for e-mail validation
 */
const RFC2822_REGEX = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/;

/**
 * A set of default validators
 */
const VALIDATORS = {
  required: (field) => {
    return field.value ? true : false;
  },

  email: (field) => {
    return !field.value || RFC2822_REGEX.test(field.value);
  }
};

/**
 * Validate form data, configurable by a data-validate attribute
 */
class ValidationParser {

  constructor(el, options = {}) {
    this.el = el;
    this.options = options;
    this.validators = VALIDATORS;

    this.searchDOMForValidationSubjects = this.searchDOMForValidationSubjects.bind(this);
  }

  /**
   * Look for validation subjects beneath the given reference node
   *
   * @param {DOMNode} referenceNode
   * @return Array
   * @private
   */
  searchDOMForValidationSubjects(referenceNode) {
    let subjects = [];
    [].forEach.call(referenceNode.querySelectorAll('[data-validate]'), (el) => {
      el.dataset.validate.split('|').forEach((validatorKey) => {
        if (this.validators[validatorKey]) {
          subjects.push({
            el,
            validator: () => VALIDATORS[validatorKey](el) ? true : validatorKey
          });
        } else {
          console.warn(`Validator ${validatorKey} is not defined.`);
        }
      });
    });

    return subjects;
  }

  /**
   * Extend the ValidationParser with a new validator and its corresponding
   * error message
   *
   * @param {String} key
   * @param {Function} callback
   * @param {Function} message
   */
  addValidator(key, callback, message) {
    this.messages[key] = message;
    this.validators[key] = callback;
  }

  /**
   * Validate form data according to configuration
   *
   * @return {Boolean}
   */
  validate() {
    let isValid = true;
    let subjects = this.searchDOMForValidationSubjects(this.el);

    this.options.beforeValidation && this.options.beforeValidation();
    subjects.forEach((subject) => {
      let validationResult = subject.validator();

      if (true !== validationResult) {
        isValid = false;
        if(this.options.onValidationFailed) {
          this.options.onValidationFailed(subject.el, validationResult);
        }
      }
    });

    return isValid;
  }
}

module.exports = ValidationParser;
